<template>
    <div class="product_wrap">
        <div v-if="product.ClassImages" class="product_banner">
            <swiper :options="swiperOption">
                <swiper-slide v-for="(src, index) in product.ClassImages" v-bind:key="index">
                    <img :src="src" :alt="product.ClassTitle">
                </swiper-slide>
                <div id="banner-pagination" class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                <div id="banner-button-prev" class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                <div id="banner-button-next" class="swiper-button-next swiper-button-white" slot="button-next"></div>
            </swiper>
        </div>
        <div class="product_content">
            <div class="container">
                <breadcrumbs :dom="crumbsItem" />
                <div class="row">
                    <div class="col-xl-9">
                        <div class="title_item posr">
                            <div class="row">
                                <div class="col-auto" v-if="product.HotSell">
                                    <b class="hot_tag">{{ product.HotSell }}</b>
                                </div>
                                <div class="col-sm-9">
                                    <h2>{{ product.ClassTitle }}</h2>
                                </div>
                            </div>
                            <div class="texthtml" v-dompurify-html="product.ClassSummary">

                            </div>
                            <ul>
                                <li v-for="(tag, index) in product.ClassTab" :key="index">
                                    <router-link :to="{ name:'searchresults', query: { keyword: tag } }" class="hoverFill">
                                        {{ tag }}
                                    </router-link>
                                </li>
                            </ul>
                            <a @click="addCollection(product)" href="javascript:;" class="blot posa" :class="{ active: product.Favorites }">收藏</a>
                        </div>
                        <div class="content_section">
                            <h3>課程說明</h3>
                            <div class="texthtml" v-dompurify-html="product.ClassContent"></div>

                            <h3>開課門檻</h3>
                            <div class="texthtml" v-dompurify-html="product.OpenThreshold"></div>

                            <h3>費用說明</h3>
                            <h6>費用</h6>
                            <div class="texthtml" v-dompurify-html="product.Fee"></div>
                            <h6>說明</h6>
                            <div class="texthtml" v-dompurify-html="product.FeeContent"></div>

                            <h3>退費說明</h3>
                            <div class="texthtml" v-dompurify-html="product.RefundContent"></div>

                            <h3>注意事項</h3>
                            <div class="texthtml" v-dompurify-html="product.RemindContent"></div>
                        </div>
                        <div class="class_info_section">
                            <h3>開課資訊</h3>
                            <table class="table table_rwd" aria-label="開課資訊">
                                <thead>
                                    <tr class="tr_hide">
                                        <th>上課時間</th>
                                        <th>開課店別</th>
                                        <th>人數名額</th>
                                        <th>上課地址</th>
                                        <th>連絡電話</th>
                                        <th v-if="teachShow">師資介紹</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="Trli" v-for="(info, index) in product.ClassInfoGroup" :key="index">
                                        <td data-th="上課時間">{{ info.ClassTime }}</td>
                                        <td data-th="開課店別">
                                            <button type="button" class="map_link" @click="openGoogleMap(info.ClassAddress)">
                                                <img :src="require(`@/assets/images/icon/map.svg`)" class="map_arrow" alt="查看地圖">
                                            </button>
                                            {{ info.BranchName }}
                                        </td>
                                        <td data-th="人數名額">{{ info.PeopleLimit }}</td>
                                        <td data-th="上課地址">{{ info.ClassAddress }}</td>
                                        <td data-th="連絡電話">{{ info.Telephone }}</td>
                                        <td data-th="師資介紹" :class="{ clickable: info.TeacherCV }" v-b-modal="`teacher_modal_${index}`" v-if="info.TeachName">{{ info.TeachName }}</td>
                                        <teacher-modal v-if="info.TeacherCV" :cv="info.TeacherCV" :modal-id="index" />
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col">
                        <div class="aside_right">
                            <div class="price">
                                <div class="row">
                                    <div class="col-8 col-sm-7 col-xl-10">
                                        <div class="row">
                                            <template v-if="price.EarlyBirdDiscount">
                                                <div class="col-5">
                                                    <p class="justify">早鳥優惠</p>
                                                </div>
                                                <div class="col-7">
                                                    <p class="num">
                                                        <span class="pageTextRed">{{ price.EarlyBirdDiscount | currency }}</span>
                                                        起
                                                    </p>
                                                </div>
                                            </template>
                                            <div class="col-5">
                                                <p class="justify">定價</p>
                                            </div>
                                            <div class="col-7">
                                                <p class="num">
                                                    <span class="pageTextBlack">{{ price.FixedPrice | currency }}</span>
                                                    起
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4 col-sm-5 col-xl-2">
                                        <div class="row">
                                            <a href="javascript:void(0);" v-b-modal.class_qrcode_modal>
                                                <!-- <img :src="require(`@/assets/images/pic/qr_code.png`)"> -->
                                                <qriously :value="safePageUrl" class="qrcode" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sponsor">
                                <div class="row">
                                    <div class="col-xl-4">
                                        <img :src="require(`@/assets/images/icon/time_small.svg`)" alt="">
                                        <h4>開始報名</h4>
                                    </div>
                                    <div class="col-xl-8">
                                        <p>{{ price.ClassDate }}</p>
                                    </div>
                                    <div class="col-xl-4">
                                        <img :src="require(`@/assets/images/icon/suitable_small.svg`)" alt="">
                                        <h4>適用對象</h4>
                                    </div>
                                    <div class="col-xl-8">
                                        <p>{{ price.SuitableObject }}</p>
                                    </div>
                                    <div class="col-xl-4">
                                        <img :src="require(`@/assets/images/icon/home_small.svg`)" alt="">
                                        <h4>主辦單位</h4>
                                    </div>
                                    <div class="col-xl-8">
                                        <p>{{ price.Organizers }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <template v-if="this.isLogin">
                                    <!-- <router-link v-if="price.ISValid" :to="to" class="link hoverShallow">
                                        {{ price.RegisteredText }}
                                    </router-link> -->
                                    <a v-if="price.ISValid" href="javascript:;" class="link hoverShallow" @click="next()">{{ price.RegisteredText }}</a>

                                    <button v-else class="link" type="button" disabled>
                                        {{ price.RegisteredText }}
                                    </button>
                                </template>
                                <template v-else>
                                    <a href="javascript:;" v-if="price.ISValid" v-b-modal.login_modal class="link hoverShallow">
                                        {{ price.RegisteredText }}
                                    </a>
                                </template>
                            </div>
                            <div class="course">
                                <img :src="require(`@/assets/images/icon/info_small.svg`)" alt="">
                                <h4>開課資訊</h4>
                                <div class="info row" v-for="(info, index) in product.ClassInfoGroup" :key="index">
                                    <div class="col-sm-7">{{ info.ClassTime }}</div>
                                    <div class="col-sm-5">人數名額 {{ info.PeopleLimit }}</div>
                                        <div class="col-sm-3">
                                            <img :src="require(`@/assets/images/icon/map_menu_hover.svg`)" alt="">
                                            {{ info.BranchName }}
                                        </div>
                                    <div class="col-sm-9">{{ info.ClassAddress }}</div>
                                    <div class="col">{{ info.Telephone }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Recommend :class-id="product.ClassID" />
        <ClassQrCodeModal :page-url="safePageUrl"></ClassQrCodeModal>
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'
    import LightBox from '@/plugin/vue-image-lightbox/src/components/LightBox.vue'
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import ProductItem from '@/components/products/items/Item'
    import ProductItemBox from '@/components/products/items/ItemBox'
    import Recommend from '@/components/products/partials/Recommend'
    import ClassQrCodeModal from '@/components/modal/ClassQrCodeModal'
    import classApi from '@/api/class'
    import orderApi from '@/api/order'
    import classificationsMixin from '@/mixins/classifications'
    import addCollectionMixin from '@/mixins/addCollection'
    import userMixin from '@/mixins/user'
    import TeacherModal from '@/components/modal/Teacher'
    import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [
            classificationsMixin,
            addCollectionMixin,
            userMixin
        ],
        components: {
            Breadcrumbs,
            ProductItem,
            ProductItemBox,
            LightBox,
            Recommend,
            ClassQrCodeModal,
            TeacherModal,
        },
        props: [
            'parentid',
            'id'
        ],
        data() {
            return {
                swiperOption: {
                    spaceBetween: 30,
                    effect: 'fade',
                    pagination: {
                        el: '#banner-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '#banner-button-next',
                        prevEl: '#banner-button-prev'
                    }
                },
                show: false,
                isActive: false,
                product: {},
                price: {},
            }
        },
        computed: {
            ...mapGetters('user', ['isLogin']),
            safePageUrl() {
                const { origin, pathname, search, hash } = window.location;
                return `${origin}${pathname}${search}${hash}`;
            },
            productItemImages() {
                let productItemImages = _.get(this.product, 'ActivityHighlights', []);
                return productItemImages.map((src) => {
                    return {
                        src,
                        thumb: src,
                    };
                })
            },
            to() {
                return {
                    name: 'products.register',
                    params: {
                        parentid: this.parentid,
                        id: this.id,
                    }
                };
            },
            crumbsItem() {
                return [{
                        text: '首頁',
                        to: {
                            name: 'home'
                        },
                    },
                    {
                        text: this.getClassificationNameById(this.parentid),
                        to: {
                            name: 'products.index',
                            params: {
                                id: this.parentid,
                            },
                        },
                    },
                    {
                        text: this.product.ClassTitle,
                        active: true
                    },
                ];
            },
            teachShow() {
                let result = false
                if (this.product.ClassInfoGroup) {
                    for(let classInfo of this.product.ClassInfoGroup) {
                        if(classInfo.TeachName != '') {
                            result = true
                        }
                    }
                }
                return result;
            },
            queryFilter() { // 檢測用
                return {
                    OrderBTime: null,
                    OrderETime: null,
                    Keyword: '',
                    PayType: 3,
                    CurrentPage: 1,
                    PerPage: 1
                };
            },
        },
        watch: {
            id() {
                this.init();
            },
        },
        created() {
            window.addEventListener('scroll', this.windowScroll)
            window.addEventListener('resize', this.windowScroll)

            this.init();
        },
        destroyed() {
            window.removeEventListener('scroll', this.windowScroll);
            window.addEventListener('resize', this.windowScroll);
            const metaTags = document.querySelectorAll('meta[property^="og:"]');
            metaTags.forEach((metaTag) => {
              metaTag.parentNode.removeChild(metaTag);
            });
        },
        methods: {
            next() {
                this.checkUser();
            },
            init() {
                this.getQueryExplanation();
                this.getQueryPrice();
            },
            initUser() {
                this.getQueryExplanation();
                this.getQueryPrice();
            },
            getQueryExplanation() {
                this.product = {};
                classApi.queryExplanation({
                    InitID: this.id
                }, (data) => {
                    this.product = data ? data : {};
                    this.$set(this.product, 'InitID', this.id);
                    this.generateMetaTag(this.product.ClassTitle, this.product.ClassSummary, this.product.metaImageUrl);
                });
            },
            getQueryPrice() {
                this.price = {};
                classApi.queryPrice({
                    InitID: this.id
                }, (data) => {
                    this.price = data ? data : {};
                });
            },
            windowScroll() {
                let HeaderH = _.get(document.querySelector('header'), 'clientHeight'),
                    ProBanner = _.get(document.querySelector('.product_banner'), 'clientHeight'),
                    Crumbs = _.get(document.querySelector('.breadcrumbs'), 'clientHeight'),
                    WindowTop = window.pageYOffset,
                    WindowWidth = $(window).width(),
                    MainH = _.get(document.querySelector('main'), 'clientHeight'),
                    FooterH = _.get(document.querySelector('footer'), 'clientHeight'),
                    ProRecom = _.get(document.querySelector('.product_recommended'), 'clientHeight')
                // eslint-disable-next-line
                $(document).ready(() => {
                    let $asideRight = $('.aside_right'),
                        asWidth = $('.aside_right').innerWidth()
                    if (WindowWidth > 1200) {
                        if (WindowTop >= HeaderH + ProBanner - (Crumbs * 2)) {
                            if (WindowTop >= MainH - HeaderH - $(window).height()) {
                                $asideRight.css({
                                    'opacity': '0',
                                    'pointer-events': 'none'
                                })
                            } else {
                                $asideRight.css({
                                    'opacity': '1',
                                    'pointer-events': 'auto',
                                    'width': asWidth,
                                    'position': 'fixed',
                                    'top': '14vh',
                                    'z-index': '2'
                                })
                            }
                        } else {
                            $asideRight.removeAttr('style')
                        }
                    } else {
                        if (WindowTop >= MainH - (FooterH + ProRecom) - $(window).height()) {
                            $asideRight.css({
                                'opacity': '0',
                                'pointer-events': 'none'
                            })
                        } else {
                            $asideRight.removeAttr('style')
                        }
                    }
                    if (WindowWidth < 1200) {
                        if (WindowTop >= MainH - (HeaderH + FooterH) - $asideRight.outerHeight(true) - $(window).height()) {
                            $asideRight.css({
                                'opacity': '0',
                                'pointer-events': 'none'
                            })
                        }
                    }
                })
            },
            openGallery(index) {
                this.$refs.lightbox.showImage(index)
            },
            googleMapUrl(address) {
                return `https://maps.google.com/?q=${encodeURIComponent(address || '')}`;
            },
            openGoogleMap(address) {
                const mapWindow = window.open(this.googleMapUrl(address), '_blank', 'noopener');
                if (mapWindow) {
                    mapWindow.opener = null;
                }
            },
            // 純粹用來偵測token有無過期
            checkUser() {
                orderApi.checkUser(() => {
                    this.$router.push({
                        name: 'products.register',
                        params: {
                            parentid: this.parentid,
                            id: this.id,
                        }
                    });
                });
                
            },
            generateMetaTag(title, description, imageUrl) {
                // Create new meta tags
                const metaImage = document.createElement('meta');
                metaImage.setAttribute('property', 'og:image');
                metaImage.setAttribute('content', imageUrl);
                document.head.appendChild(metaImage);
                const metaTitle = document.createElement('meta');
                metaTitle.setAttribute('property', 'og:title');
                metaTitle.setAttribute('content', title + ' | HOLA 和樂家居');
                document.head.appendChild(metaTitle);
                const metaDescription = document.createElement('meta');
                metaDescription.setAttribute('property', 'og:description');
                metaDescription.setAttribute('content', description);
                document.head.appendChild(metaDescription);
            }
        },
    }
</script>
